import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'analytics/insights',
  size: 'full',
  children: {
    headcount: {
      path: 'headcount',
      size: 'full',
    },
  },
} as const satisfies Location
